















import { container } from 'tsyringe';
import { defineComponent, ref, Ref, watch } from '@vue/composition-api';
import { ModelManager } from './prototyping/model';
import CookieBanner from './components/CookieBanner.vue';

// the transition resets after each transition to 'crossfade-flow'
export const currentTransition = ref('crossfade-flow');

export default defineComponent({
  components: {
    CookieBanner
  },
  setup(props, context) {
    const view: Ref<HTMLElement | null> = ref(null);

    function beforeEnter() {
      // eslint-disable-next-line
      (context.root.$el as HTMLDivElement).style.overflow = 'hidden';
    }
    function afterLeave() {
      // reset transition
      currentTransition.value = 'crossfade-flow';
      // eslint-disable-next-line
      (context.root.$el as HTMLDivElement).style.overflow = '';
    }

    const audioPlayer = container.resolve(ModelManager).get('audio-player', 'AudioPlayerModel');
    const audioLib = container.resolve(ModelManager).get('audio-lib', 'StoryblokAudioLibModel');

    watch(audioPlayer.currentAudioTrack, (at) => {
      if (at) {
        const audioTrackInfo = audioLib.state.audioLib.find((ti) => ti.newAudioFile?.audio === at.src || ti.audioFile?.filename === at.src);
        if (audioTrackInfo) {
          document.title = `${audioTrackInfo.artist} - ${audioTrackInfo.title}`;
          return;
        }
      }
      document.title = 'Vinylpostcards';
    });

    return {
      afterLeave,
      beforeEnter,
      view,
      currentTransition,
    };
  },
});
